import { toast } from "sonner";

const toText = (message) => {
  if (message == null) return "Something went wrong";
  if (typeof message === "string") return message;
  if (typeof message === "object" && message?.message) return String(message.message);
  return String(message);
};

export const showSuccessAlert = (message) => {
  toast.success(toText(message), {
    position: "top-right",
  });
};

export const showErrorAlert = (message) => {
  toast.error(toText(message), {
    position: "top-right",
  });
};
